import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/jcasecurity/update_pairs';

const initialState = {
    jcaQA1Answer: '',
    jcaQA1AlternativeSolution: '',
    jcaQA2Answer11: '',
    jcaQA2Answer12: '',
    jcaQA2Answer13: '',
    jcaQA2Answer14: '',
    jcaQA2Answer21: '',
    jcaQA2Answer22: '',
    jcaQA2Answer23: '',
    jcaQA2Answer24: '',
    jcaQA2Answer25: '',
    jcaQA2Answer31: '',
    jcaQA2Answer32: '',
    jcaQA2Answer33: '',
    jcaQA2Answer34: '',
    jcaQA2AlternativeSolution: '',
};

const form = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PAIRS: {
            return {
                ...state,
                ...action.pairs,
            };
        }
        case PURGE_DATA: {
            return initialState;
        }
        default:
            return state;
    }
};

export const updatePairs = pairs => ({
    type: UPDATE_PAIRS,
    pairs,
});

export default form;
